import React, { useState } from 'react';

function FeaturePanel({ title, icon, children, screenshot, screenshotHeight = '288px', screenshotWidth = '384px' }) {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="relative group max-w-md mx-auto transition-all duration-300 hover:-translate-y-1">
      {/* Gradient border effect - thicker and more visible */}
      <div className="absolute -inset-[1.5px] bg-gradient-to-br from-blue-500/50 via-purple-500/30 to-blue-500/50 rounded-xl 
        group-hover:from-blue-500/70 group-hover:via-purple-500/50 group-hover:to-blue-500/70 transition-all duration-300" />
      
      <div className="relative bg-gray-900/95 p-5 rounded-xl h-full
        transition-all duration-300
        group-hover:shadow-2xl group-hover:shadow-purple-500/20
        shadow-lg shadow-black/20">
        <div className="text-4xl mb-4 transition-transform duration-300 group-hover:scale-110">{icon}</div>
        <h2 className="text-2xl font-bold mb-4 text-white">{title}</h2>
        <div className={`${screenshot ? '' : 'bg-gray-700'} mb-4 rounded-lg flex items-center justify-center overflow-hidden relative`} style={{height: screenshotHeight}}>
          {screenshot && (
            <>
              {!imageLoaded && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-900/80">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div>
                </div>
              )}
              <img 
                src={screenshot} 
                alt={title} 
                className={`rounded-lg transition-all duration-500 ${imageLoaded ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
                style={{
                  width: screenshotWidth,
                  height: screenshotHeight,
                  objectFit: 'contain'
                }}
                onLoad={() => setImageLoaded(true)}
              />
            </>
          )}
          {!screenshot && <div>[Screenshot Placeholder]</div>}
        </div>
        <p className="text-gray-300">{children}</p>
      </div>
    </div>
  );
}

export default FeaturePanel;
